import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EmployeeDetails } from "./employee-details.entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('employee_idproof_details')
export class EmployeeIdProofDetails {

    @PrimaryGeneratedColumn("increment", { name: 'employee_idproof_id' })
    employeeIdProofId: number;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "id_type"
    })
    idType: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "id_number"
    })
    idNumber: string;
 

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => EmployeeDetails, empInfo => empInfo.idProofDetails, { nullable: true, })
    @JoinColumn({ name: "emp_id" })
    employeeDetails: EmployeeDetails;


}
